import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    hidden: true,
    path: '/',
    component: Layout,
    redirect: '/console',
    children: [
      {
        path: 'console',
        component: () => import('@/views/console/index'),
        name: 'Console',
        meta: { title: '控制台', icon: 'dashboard', affix: true }
      }
    ]
  },

  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'Profile', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/certificate',
    component: Layout,
    redirect: '/certificate/certificateList',
    alwaysShow: true, // will always show the root menu
    name: 'Certificate',
    meta: {
      title: '凭证',
      icon: 'documentation'
    },
    children: [
      {
        path: 'addCertificate',
        click: () => {
          router.push({
            path: '/certificate/addCertificate',
            query: { r: new Date().getTime() }
          });
        },
        component: () => import('@/views/certificate/addCertificate'),
        name: 'AddCertificate',
        meta: {
          title: '凭证录入',
          singleTab: true
        }
      },
      {
        path: 'editCertificate',
        component: () => import('@/views/certificate/editCertificate'),
        name: 'EditCertificate',
        hidden: true,
        meta: {
          title: '凭证编辑',
          singleTab: true
        }
      },
      {
        path: 'certificateList',
        component: () => import('@/views/certificate/certificateList'),
        name: 'CertificateList',
        meta: {
          title: '凭证列表'
        }
      },
      {
        path: 'billList/:uid',
        component: () => import('@/views/certificate/billList'),
        name: 'BillList',
        hidden: true,
        meta: {
          title: '出入库单详情'
        }
      },
      {
        path: 'allCertificate',
        component: () => import('@/views/certificate/allCertificate'),
        name: 'AllCertificate',
        meta: {
          title: '凭证汇总表'
        }
      },
      {
        path: 'businessCertificate',
        component: () => import('@/views/certificate/businessCertificate'),
        name: 'BusinessCertificate',
        meta: {
          title: '业务凭证'
        }
      },
      {
        path: 'bills',
        component: () => import('@/views/bills/list'),
        name: 'BillsList',
        meta: {
          title: '进销存凭证'
        }
      }
    ]
  },
  {
    path: '/ledger',
    component: Layout,
    redirect: '/ledger/detail',
    alwaysShow: true, // will always show the root menu
    name: 'Ledger',
    meta: {
      title: '账簿',
      icon: 'zhangbu'
    },
    children: [
      {
        path: 'detail',
        component: () => import('@/views/ledger/detail'),
        name: 'LedgerDetail',
        meta: {
          title: '明细账'
        }
      },
      {
        path: 'summary',
        component: () => import('@/views/ledger/summary'),
        name: 'LedgerSummary',
        meta: {
          title: '总账'
        }
      },
      {
        path: 'subjectBalance',
        component: () => import('@/views/ledger/subjectBalance'),
        name: 'LedgerSubjectBalance',
        meta: {
          title: '科目余额表'
        }
      },
      {
        path: 'accProjectDetail',
        component: () => import('@/views/ledger/accProjectDetail'),
        name: 'LedgerAccProjectDetail',
        meta: {
          title: '核算项目明细账'
        }
      },
      {
        path: 'accProjectBalance',
        component: () => import('@/views/ledger/accProjectBalance'),
        name: 'LedgerAccProjectBalance',
        meta: {
          title: '核算项目余额表'
        }
      }
    ]
  },
  {
    path: '/report',
    component: Layout,
    redirect: '/report/assetload',
    alwaysShow: true, // will always show the root menu
    name: 'Report',
    meta: {
      title: '报表',
      icon: 'chart'
    },
    children: [
      {
        path: 'assetload',
        component: () => import('@/views/report/assetload'),
        name: 'ReportAssetload',
        meta: {
          title: '资产负债表'
        }
      },
      {
        path: 'profit',
        component: () => import('@/views/report/profit'),
        name: 'ReportProfit',
        meta: {
          title: '利润表'
        }
      },
      {
        path: 'profitDepartment',
        component: () => import('@/views/report/profit/department'),
        name: 'ReportProfitDepartment',
        meta: {
          title: '门店利润表'
        }
      },
      {
        path: 'cashflow',
        component: () => import('@/views/report/cashflow'),
        name: 'ReportCashflow',
        meta: {
          title: '现金流量表'
        }
      },
      {
        path: 'adjust',
        component: () => import('@/views/report/adjust'),
        name: 'ReportAdjust',
        meta: {
          title: '调整现金流量表'
        },
        hidden: true
      },
      {
        path: 'custom',
        component: () => import('@/views/report/custom/index'),
        name: 'CustomReport',
        meta: {
          title: '自定义报表'
        }
      },
      {
        path: 'customEdit',
        component: () => import('@/views/report/custom/edit'),
        name: 'CustomReportEdit',
        meta: {
          title: '编辑自定义报表',
          singleTab: true
        },
        hidden: true
      }
    ]
  },
  // {
  //   path: '/reportMerge',
  //   component: Layout,
  //   redirect: '/reportMerge/assetloadMerge',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'ReportMerge',
  //   meta: {
  //     title: '合并报表',
  //     icon: 'chart'
  //   },
  //   children: [
  //     {
  //       path: 'assetloadMerge',
  //       component: () => import('@/views/reportMerge/assetloadMerge'),
  //       name: 'ReportAssetloadMerge',
  //       meta: {
  //         title: '综合资产负债表'
  //       }
  //     },
  //     {
  //       path: 'profitMerge',
  //       component: () => import('@/views/reportMerge/profitMerge'),
  //       name: 'ReportProfitMerge',
  //       meta: {
  //         title: '综合利润表'
  //       }
  //     },
  //     {
  //       path: 'cashflowMerge',
  //       component: () => import('@/views/reportMerge/cashflowMerge'),
  //       name: 'ReportCashflowMerge',
  //       meta: {
  //         title: '综合现金流量表'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/asset',
    component: Layout,
    redirect: '/report/manage',
    alwaysShow: true, // will always show the root menu
    name: 'Asset',
    meta: {
      title: '固定资产',
      icon: 'component'
    },
    children: [
      {
        path: 'manage',
        component: () => import('@/views/asset/manage'),
        name: 'AssetManage',
        meta: {
          title: '固定资产管理'
        }
      },
      {
        path: 'depreciation',
        component: () => import('@/views/asset/depreciation'),
        name: 'AssetDepreciation',
        meta: {
          title: '固定资产折旧统计表'
        }
      },
      {
        path: 'sub-ledger',
        component: () => import('@/views/asset/sub-ledger'),
        name: 'AssetSubLedger',
        meta: {
          title: '固定资产明细账'
        }
      },
      {
        path: 'type',
        component: () => import('@/views/asset/type'),
        name: 'AssetType',
        meta: {
          title: '固定资产类别'
        }
      }
    ]
  },
  {
    path: '/settle',
    component: Layout,
    redirect: '/settle/settle',
    children: [
      {
        path: 'settle',
        component: () => import('@/views/settle/settle'),
        name: 'Settle',
        meta: {
          title: '结账',
          icon: 'education'
        }
      }
    ]
  },
  {
    path: '/cashier',
    component: Layout,
    redirect: '/cashier/diary',
    alwaysShow: true,
    name: 'Cashier',
    meta: {
      title: '出纳',
      icon: 'money'
    },
    children: [
      {
        path: 'diary',
        name: 'CashierDiary',
        meta: {
          title: '日记账'
        },
        component: () => import('@/views/cashier/diary')
      },
      {
        path: 'verifiedLedger',
        name: 'CashierVerifiedLedger',
        meta: {
          title: '核对总账'
        },
        component: () => import('@/views/cashier/verifiedLedger')
      },
      {
        path: 'account',
        name: 'CashierAccount',
        meta: {
          title: '账户'
        },
        component: () => import('@/views/cashier/account')
      }
    ]
  },
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/config',
    alwaysShow: true, // will always show the root menu
    name: 'Setting',
    meta: {
      title: '设置',
      icon: 'gear'
    },
    children: [
      {
        path: 'config',
        component: () => import('@/views/setting/config'),
        name: 'SettingConfig',
        meta: {
          title: '系统参数'
        }
      },
      {
        path: 'subject',
        component: () => import('@/views/setting/subject'),
        name: 'SettingSubject',
        meta: {
          title: '科目'
        }
      },
      {
        path: 'assist',
        component: () => import('@/views/setting/assist'),
        name: 'SettingAssist',
        meta: {
          title: '辅助核算',
          noCache: true
        }
      },
      {
        path: 'business',
        component: () => import('@/views/setting/business'),
        name: 'SettingBusiness',
        meta: {
          title: '业务科目对照表'
        }
      },
      {
        path: 'relasystem',
        component: () => import('@/views/setting/relasystem'),
        name: 'SettingRelasystem',
        meta: {
          title: '关联进销存',
          noCache: true
        }
      },
      {
        path: 'balance',
        component: () => import('@/views/setting/balance'),
        name: 'SettingBalance',
        meta: {
          title: '财务初始余额'
        }
      }
    ]
  },

  {
    path: '/wholesale/boss-report',
    component: () => import('@/views/wholesale/boss-report'),
    meta: {
      title: '老板一张表'
    },
    hidden: true
  },
  {
    path: '/wholesale/detail-report',
    component: () => import('@/views/wholesale/detail-report'),
    meta: {
      title: '明细账本'
    },
    hidden: true
  },
  {
    path: '/wholesale/profit-report',
    component: () => import('@/views/wholesale/profit-report'),
    meta: {
      title: '经营情况（利润）表'
    },
    hidden: true
  }
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
